import { ref } from '@vue/composition-api';
export default function useBoolean() {
  var value = ref(false);
  var setTrue = function setTrue() {
    value.value = true;
  };
  var setFalse = function setFalse() {
    value.value = false;
  };
  var toggle = function toggle() {
    value.value = !value.value;
  };
  return [value, {
    setFalse: setFalse,
    setTrue: setTrue,
    toggle: toggle
  }];
}